import React, { useState } from 'react';
import CertificateIcon from '../assets/certificate-32x32.png'; // Make sure you have this icon
import { getUserProgressCertificate } from '../apis/certs.api';

const CertificateCard = ({ email, startDate, endDate }) => {
  const [certificateData, setCertificateData] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [status, setStatus] = useState('idle'); // New state for tracking status

  const handleRequestCertificate = async () => {
    setStatus('loading');
    console.log('---- handleRequestCertificate (CertificateCard 11):', email);
    try {
      const response = await getUserProgressCertificate(email, startDate, endDate);
      const data = response.data;
      // setCertificateData(data.certificateData);

    // Convert base64 to blob
    const pdfContent = atob(data.pdf);
    const pdfBlob = new Blob(
      [new Uint8Array(pdfContent.split('').map(char => char.charCodeAt(0)))],
      { type: 'application/pdf' }
    );
    console.log('---- pdfBlob (CertificateCard 25):', pdfBlob)
    // Create blob URL
    const pdfUrl = URL.createObjectURL(pdfBlob);
    console.log('---- pdfUrl (CertificateCard 28):', pdfUrl)
    // Open in new tab
    window.open(pdfUrl, '_blank');

      // setPdf(data.pdf);
      // setPdfUrl(data.pdfUrl);
      setStatus('success');
      console.log('---- handleRequestCertificate (CertificateCard 16):', data);
    } catch (error) {
      console.error('Error fetching certificate:', error);
      setStatus('error');
      setTimeout(() => setStatus('idle'), 3000); // Reset status after 3 seconds
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-6 flex flex-col justify-between h-full">
      <div>
        <div className="flex items-center mb-4">
          <img src={CertificateIcon} alt="Certificate Icon" className="w-8 h-8 mr-3" />
          <h2 className="text-xl font-semibold">Congratulations on your achievements!</h2>
        </div>
      </div>

      {pdfUrl != null ? (
        <a href={pdfUrl} target="_blank" className="bg-green-600 text-white font-bold py-2 px-4 rounded mt-1 inline-block text-center">
          Your Certificate is Ready
        </a>
      ) : status === 'loading' ? (
        <div className="text-blue-600 font-bold py-2 px-4 rounded mt-1">
          Generating your certificate...
        </div>
      ) : status === 'error' ? (
        <div className="text-red-600 font-bold py-2 px-4 rounded mt-1">
          Failed to generate certificate. Please try again.
        </div>
      ) : (
        <button className="bg-blue-600 text-white font-bold py-2 px-4 rounded mt-1" onClick={handleRequestCertificate}>
          Certificate of Learning
        </button>
      )}
    </div>
  );
};

export default CertificateCard;
